enum TipoConviteStatusEnum {
  Enviado = 'Enviado',
  Reenviado = 'Reenviado',
  CadastroIniciado = 'CadastroIniciado',
  CadastroConcluido = 'CadastroConcluido',
  CadastroEmProcessamento = 'CadastroEmProcessamento',
  Erro = 'Erro',
}
export default TipoConviteStatusEnum
